import useApi from '../utils/axios-pettitions';

export const useApiAnalyzer = () => {
  const { runApi } = useApi();

  const getTrace = (IdAnalyzer, Page) => {
    return runApi('Analyzers', 'GET', {IdAnalyzer, Page}, null).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 101) {
        return res.data;
      }
    });
  };


  const getHostQuery = (IdAnalyzer, inicio, fin, orden) => {
    return runApi('Analyzers/getHostQuery', 'GET', {IdAnalyzer, inicio, fin, orden}, null).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 101) {
        return res.data;
      } 
    });
  };

  const SendDataToHostQuery = (data) => {
    return runApi('Analyzers/SendDataToHostQuery', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 101) {
        return true;
      }
    });
  }

  return { getTrace, getHostQuery, SendDataToHostQuery };
};